import { render, staticRenderFns } from "./NavOrder.vue?vue&type=template&id=6ddc68b0&scoped=true&"
import script from "./NavOrder.vue?vue&type=script&lang=js&"
export * from "./NavOrder.vue?vue&type=script&lang=js&"
import style0 from "./NavOrder.vue?vue&type=style&index=0&id=6ddc68b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc68b0",
  null
  
)

export default component.exports